import i18n from "@helpers/lib/i18n";
import { formatDate, normalizeDate } from "@memorang/helpers/date";

type PremiumUpsellCopy = {
	title: string;
	description: string;
};

export const getPremiumUpsellCopy = ({
	examDate,
	productName,
}: {
	examDate?: string;
	productName?: string;
}): PremiumUpsellCopy => {
	const parsedExamDate = normalizeDate(examDate);
	const formattedExamDate = parsedExamDate
		? formatDate(parsedExamDate, i18n.language, {
				month: "long",
				day: "numeric",
				year: undefined,
			})
		: undefined;

	return {
		title: formattedExamDate
			? i18n.t("premium.readyTitle", { date: formattedExamDate })
			: i18n.t("premium.unlockTitle", { productName }),
		description: i18n.t("premium.unlockDescription"),
	};
};
